var _circle, _circle2, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfCam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6406,
    cy: 18.75,
    r: 18,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6406,
    cy: 18.75,
    r: 17,
    stroke: "#9C4900",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_122922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.64062,
    y: 6.75,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_122922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6406 24.25C19.8906 24.25 20.9533 23.8127 21.8286 22.938C22.7033 22.0627 23.1406 21 23.1406 19.75C23.1406 18.5 22.7033 17.4373 21.8286 16.562C20.9533 15.6873 19.8906 15.25 18.6406 15.25C17.3906 15.25 16.328 15.6873 15.4526 16.562C14.578 17.4373 14.1406 18.5 14.1406 19.75C14.1406 21 14.578 22.0627 15.4526 22.938C16.328 23.8127 17.3906 24.25 18.6406 24.25ZM10.6406 27.75C10.0906 27.75 9.61996 27.5543 9.22863 27.163C8.83663 26.771 8.64062 26.3 8.64062 25.75V13.75C8.64062 13.2 8.83663 12.7293 9.22863 12.338C9.61996 11.946 10.0906 11.75 10.6406 11.75H13.7906L15.6406 9.75H21.6406L23.4906 11.75H26.6406C27.1906 11.75 27.6616 11.946 28.0536 12.338C28.445 12.7293 28.6406 13.2 28.6406 13.75V25.75C28.6406 26.3 28.445 26.771 28.0536 27.163C27.6616 27.5543 27.1906 27.75 26.6406 27.75H10.6406Z",
    fill: "#9C4900",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfCam);
export default __webpack_public_path__ + "static/media/prof_cam.1998e552821e9b393a179c30f5884e99.svg";
export { ForwardRef as ReactComponent };